import React, { useState } from "react";
import PromptIcon from "../../../assets/img/PromptConfirm.svg";
import Translation from "../../../services/translation.service";
import SimDeactivationService from "../../../services/sim-deactivation.service";
import Storage from "../../../services/storage.service";
import SpinnerTimeLoader from "../timeLoading";
import Helpers from "../../../helpers/shared.helper";
import ModalWrapperMid from "../modal-wrapper-mid";
// import FirebaseAnalytics from "../../../services/analytics.service";

export default function ProgressPrompt(props) {
    const [loading, setLoading] = useState(false);
    const handleYesModal = (e) => {
        const getFormData = Storage.get("simDeactivationData", true);
        const inPostPaidSimDeactivation = Storage.get("postpaid_sim_deactivation", true);
        if(getFormData && JSON.parse(inPostPaidSimDeactivation)) {
            Storage.set("genericAPIError", true);
            setLoading(true);
            const formData = JSON.parse(getFormData);
            let countryCode = Helpers.getCountryCodePO() || ""; 
            let phoneNumber = formData.phone
            phoneNumber = `${countryCode}${phoneNumber?.replace(/^0+/, '')}`;    
            const data = {
              number: phoneNumber,
            }
            // FirebaseAnalytics.generic_event(4);
            SimDeactivationService.postPaidLineReconnect(data)
            .then(() => {
                Storage.clear("genericAPIError");
                Storage.clear("postpaid_sim_deactivation");
                Storage.clear("simDeactivationData");
                Storage.clear("choose_sim_deactivation");
                props.handleYes(e);
            })
            .catch(() => {
                Storage.clear("genericAPIError");
                Storage.clear("postpaid_sim_deactivation");
                Storage.clear("simDeactivationData");
                Storage.clear("choose_sim_deactivation");
                props.handleYes(e);
            })
        } else {
            props.handleYes(e);
        }
    }

    return <>
    {props.openModal &&
        <ModalWrapperMid handleToggleModal={props.handleModal}>
            <div className="progress-prompt-modal">
                <img src={PromptIcon} alt="" />
                <span>{Translation.keys["stm_prompt_heading"]}</span>
                <p>{Translation.keys["stm_prompt_desc"]}</p>
                {loading ? <SpinnerTimeLoader /> :
                <div>
                    <button className={"common-button-light"} onClick={props.handleModal}>{Translation.keys["stf_cancel"]}</button>
                    <button className={"common-button"} 
                    onClick={(e) =>  {
                        handleYesModal(e);
                    }}>{Translation.keys["stf_yes"]}</button>
                </div>}
            </div>
        </ModalWrapperMid>
    }
    </>
} 
